
<div class="iwp-breadcrumbs col-12 text-center flex items-center justify-between justify-md-center">
  <ws-icon
    v-if="mobile && currentStep !== 0"
    class="icon cursor-pointer"
    name="arrow_left"
    :size="24"
    @click="flowConfigs[flowId][currentStep - 1].nav()"
  />

  <template v-for="(step, index) in flow">
    <template v-if="!mobile || (mobile && currentStep === index)">
      <span :key="'span-'+index" class="cursor-pointer" :class="{active: index === currentStep}" @click="step.nav">
        {{ $t(step.title) }}
      </span>
      <div v-if="index !== flow.length -1 && !mobile" :key="'separator-'+index">
        &mdash;
      </div>
    </template>
  </template>


  <ws-icon
    v-if="mobile && currentStep !== flow.length -1"
    name="arrow_left"
    :size="24"
    class="rotate-180 icon cursor-pointer"
  />
</div>
